export default __webpack_public_path__ + "static/media/cointracker.de01f1f5.jpg";